<template>
    <div class="form-control">
        <label>{{ label }}
            <input
                type="range"
                v-model="v"
                :min="min" :max="max" :step="step"
                :style="{ background: `linear-gradient(to right, var(--color-range-filled) 0%, var(--color-range-filled) ${ (v-min) / (max-min)*100 }%, var(--color-range-empty) ${ (v-min) / (max-min)*100 }%, var(--color-range-empty) 100%)` }"
            />
        </label>
    </div>
</template>

<script>
    export default {
        name: "RangeSlider"
    }
</script>

<script setup>

    import { ref } from "vue";

    let v = ref(0);
    const props = defineProps(['min', 'max', 'step', 'label']);

</script>
